import { render, staticRenderFns } from "./pages7.vue?vue&type=template&id=39c03473&scoped=true&"
import script from "./pages7.vue?vue&type=script&lang=js&"
export * from "./pages7.vue?vue&type=script&lang=js&"
import style0 from "./pages7.vue?vue&type=style&index=0&id=39c03473&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c03473",
  null
  
)

export default component.exports